<div *ngIf="loading"  class="dds__modal dds__loading-modal dds__d-block" tabindex="-1" role="dialog"  >
  <div class="dds__modal-dialog" role="document">
    <div class="dds__modal-content">
      <div class="dds__modal-body dds__text-center">
        <div class="dds__mb-3" id="modalId">
          <div class="dds__progress-bar">
            <div class="dds__progress-bar-standard dds__progress-bar-striped dds__progress-bar-animated"
              role="progressbar" data-showtext="true"></div>
          </div>
        </div>
        <p>Processing... Please wait.</p>
      </div>
    </div>
  </div>
</div>



<div class="dds__container">
  <div class="dds__row">
    <div class="dds__col-xl-12 dds__col-lg-12 dds__col-md-12 dds__col-sm-12">
      <div class="dds__row">
        <div *ngIf="!loading" class="dds__col-12">
          <label class="dds__h1 dds__float-left dds__mt-1" tabindex="0">
            List of articles with status as {{status}}
          </label>
          <a class='dds__btn dds__btn-secondary dds__float-right dds__mt-1' [routerLink]="'/portal'" tabindex="0"
            aria-label="Cancel button; On Click of this button it will navigate back to Dashboard Page."
            title="On Click of this button it will navigate back to Dashboard Page."
            >Back</a>
        </div>
      </div>
      <hr *ngIf="!loading" class="dds__primary_divider dds__mt-0" />
      <table data-table="dds__table" class="dds__table dds__table-hover dds__table-cmplx dds__table-striped">
        <caption class="dds__sr-only"> Dashboard Table </caption>
      </table>
      <nav class="dds__pagination dds__pagination-justified-filter" data-toggle="dds__pagination"
        aria-label="pagination">
      </nav>
    </div>
  </div>
</div>
